import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatOptionModule } from '@angular/material/core';

@Component({
    selector: 'app-copier-commande',
    templateUrl: './switch-role.component.html',
    styleUrls: ['./switch-role.component.scss'],
    imports: [
        CommonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatSelectModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        MatOptionModule
    ]
})
export class SwitchRoleComponent implements OnInit {
  public selectedRole: null | string = null;

  public roles = ['', 'ROLE_CPRA', 'ROLE_CHEF_SERVICE', 'ROLE_DIR_SOUSDIR', 'ROLE_SAF'];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<SwitchRoleComponent>
  ) {}

  ngOnInit(): void {
    if (this.data !== undefined) {
    }
  }

  public cancelSwitchRole(): void {
    this.dialog.close(undefined);
  }

  public valider(): void {
    this.dialog.close(this.selectedRole);
  }
}
